"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcShouldDisableEntity = void 0;
var _isEntityDisabled = require("./isEntityDisabled");
const calcShouldDisableEntity = (entity, disabledTooltip, forbiddenRootFolderName, forbiddenExtensions) => {
  const shouldDisableEntity = (0, _isEntityDisabled.isEntityDisabled)(entity, forbiddenRootFolderName, forbiddenExtensions);
  const extraData = {
    disabled: shouldDisableEntity,
    ...(shouldDisableEntity && {
      tooltipProps: {
        text: disabledTooltip,
        placement: "top",
        style: {
          maxWidth: "400px"
        }
      }
    })
  };
  if (!entity.children || entity.children.length === 0) {
    return {
      ...entity,
      ...extraData
    };
  }
  return {
    ...entity,
    ...extraData,
    children: entity.children.map(child => calcShouldDisableEntity(child, disabledTooltip, forbiddenRootFolderName, forbiddenExtensions))
  };
};
exports.calcShouldDisableEntity = calcShouldDisableEntity;
//# sourceMappingURL=calcShouldDisableEntity.js.map